import { render, staticRenderFns } from "./SmallClass.vue?vue&type=template&id=847d2fa8&scoped=true&"
import script from "./SmallClass.vue?vue&type=script&lang=js&"
export * from "./SmallClass.vue?vue&type=script&lang=js&"
import style0 from "./SmallClass.vue?vue&type=style&index=0&id=847d2fa8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "847d2fa8",
  null
  
)

export default component.exports